/* eslint-disable react/jsx-pascal-case */
import { Col, DatePicker, ConfigProvider, Form, Input, Row, Button, Select } from "./../../ui/ot";
import React, { useEffect, useState, useRef } from "react";
import { JoditEditor } from "./../../ui/ot";

const NewsForm = (
    {
        propsForm = null,
        formReloadCount = 0,
        onFormFinish = () => { },
        field
    }
) => {
    const [form] = Form.useForm();
    // const [files, setFiles] = useState([])
    const [content, setContent] = useState("")
    const editor = useRef(null);
    const config = {
        // readonly: false, // all options from https://xdsoft.net/jodit/doc/
        // uploader: {
        //     insertImageAsBase64URI: true,
        //     // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        // },
        // language: 'zh_tw'
        toolbar: false,
        allowResizeTags: false,
        imageDefaultWidth: "100%",
        language: 'zh_tw',
        i18n: {
            zh_tw: {
                'Default': "預設",
                'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
                    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
                Anchor: 'Anchor',
                Margins: '外邊距（Margins）',
                top: 'top',
                right: 'right',
                bottom: 'bottom',
                left: 'left',
                Classes: 'Classes',
                Src: 'Src',
                Title: 'Title',
                Link: 'Link',
                file: 'file',
                Spellcheck: '拼寫檢查',
                'Image properties': '圖片屬性',
                'Your code is similar to HTML. Keep as HTML?':
                    '你黏貼的文本是一段html代碼，是否保留源格式',
                'Paste as HTML': 'html黏貼',
                'Insert as Text': '把html代碼視為普通文本',
                'Error on load list': '加載list錯誤',
                Break: 'Pause',
                'No follow': 'No follow',
                'URL': 'URL',
                Crop: 'Crop',
                Default: '默認',
                Circle: '圓圈',
                Dot: '點',
                Quadrate: '方形',
                Find: '搜尋',
                'Insert className': '插入標籤名稱',
                'Press Alt for custom resizing': '按Alt自定義調整大小',
                'Find Next': '找下一個',
                'Find Previous': '找上一個',
                'replace': '替代',
                'Line height': '行高'
            }
        },
    };
    // const {
    //     EditorMessageData,
    //     getEditorMessageData,
    //     postEditorMessageData,
    //     patchEditorMessageData,
    //     deleteEditorMessageData,
    // } = useEditorMessage({
    //     onFinish: () => { },
    //     onBefore: () => { }
    // })
    // const {
    //     newsTypeOption,
    //     getNewsTypeOption,

    //     NewsTypeData,
    // } = useNewsType({
    //     onFinish: () => { },
    //     onBefore: () => { }
    // })
    // const {
    //     getNewsWeightTypeOption,
    //     newsWeightTypeOption
    // } = useNewsWeightType({
    //     onFinish: () => { },
    //     onBefore: () => { }
    // })
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }
    // const onChangeFileValue = (values) => {
    //     console.log('onChangeFileValue KENNY')

    //     let file = values?.file ?? []
    //     setFiles(file)
    // }
    // const setDataInitialization = () => {
    //     console.log('setDataInitialization KENNY')

    //     //拿個下拉選單等等的資訊
    //     getNewsTypeOption()
    //     getNewsWeightTypeOption()
    // }
    const onFinish = (values) => {
        const formValues = propsForm ? propsForm.getFieldsValue() : form.getFieldsValue();
        onFormFinish({
            ...values,
            editor_message_id: formValues.editor_message_id  // 保留 editor_message_id
        })
    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }

    const onContentChange = (content) => {
        console.log({
            current: editor.current
        })
        setContent(content)
        if (propsForm) {
            propsForm.setFieldValue([field?.name, 'editor_message'].join('.'), content)
        }
        else {
            form.setFieldValue([field?.name, 'editor_message'].join('.'), content)
        }
    }
    // const disabledDate = (current) => {
    //     // Can not select days before today and today
    //     return current && current < dayjs().subtract(1, "day").endOf('day');
    // };
    // const range = (start, end) => {
    //     const result = [];
    //     for (let i = start; i < end; i++) {
    //         result.push(i);
    //     }
    //     return result;
    // };

    // const disabledDateTime = (current) => ({
    //     disabledHours: () => {
    //         let hour = dayjs().format("HH")
    //         let todayDate = dayjs().format('YYYY-MM-DD')
    //         let currentDate = dayjs(current).format('YYYY-MM-DD')
    //         if (todayDate === currentDate) {
    //             return range(0, 24).splice(0, parseInt(hour))
    //         }
    //         else {
    //             return range(0, 24).splice(0, 0)
    //         }
    //     },
    //     disabledMinutes: () => {
    //         let minutes = dayjs().format("mm")
    //         let hour = dayjs().format("HH")
    //         let todayDate = dayjs().format('YYYY-MM-DD')
    //         let currentDate = dayjs(current).format('YYYY-MM-DD')
    //         let currentHour = dayjs(current).format('HH')
    //         if (todayDate === currentDate && currentHour === hour) {
    //             return range(0, 60).splice(0, parseInt(minutes) + 5)
    //         }
    //         else {
    //             return range(0, 0)
    //         }
    //     },
    //     disabledSeconds: () => {
    //         return range(0, 0)
    //     },
    // });

    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldValue(field?.name)
        }
        else {
            formValues = form.getFieldValue(field?.name)
        }
        // setFormValuesOtherThings(formValues)
        // onChangeFileValue(formValues)
        onContentChange(formValues?.editor_message ?? "")
    }, [formReloadCount])

    return (
        <Row>

            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Col span={24}>
                                <Form.Item
                                    hidden={true}
                                    name={[field?.name, "editor_message_id"]}

                                >
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label={"內容"}
                                    name={[field?.name, "editor_message"]}
                                    rules={[
                                        {
                                            required: true,
                                            message: "請輸入"
                                        }
                                    ]}
                                    hidden={true}
                                >
                                    <Input.TextArea>
                                    </Input.TextArea>
                                </Form.Item>
                            </Col>
                            <JoditEditor
                                ref={editor}
                                value={content}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                onBlur={onContentChange} // preferred to use only this option to update the content for performance reasons
                                height={1000}
                                allowResizeX={true}
                                allowResizeY={true}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>


    )
}


export default NewsForm;
